import { useAppSelector, useAppDispatch } from 'store/store-hooks';

import { newClip } from 'components/app/_helpers/_app.helper';
import { Error } from 'components/app/_helpers/app-errors.helper';
import { passFileAccessedAt } from 'components/app/_mediator/app-files.slice';
import { selectSelectedFile } from 'components/app/_mediator/app-files.slice';
import { handleClips, selectStats } from 'components/app/editor/_mediator/editor.slice';
import { setRecentlyMovedClips } from 'components/app/editor/_mediator/editor-controls.slice';
import { sbApi } from './editor-clips-sb.helper';
import { clipsApi } from './editor-clips.helper';

export const useClipsAddImg = () => {
  const { activeClip, storyBoard, linkedClips, selector } = useAppSelector((state) => state.editor);
  const sbPosition = useAppSelector((state) => state.editor__controls.sbPosition);
  const selectedFile = useAppSelector(selectSelectedFile);
  const stats = useAppSelector(selectStats);
  const dispatch = useAppDispatch();

  return () => {
    if (!stats || !selectedFile || !selector) return;
    if (selector[selectedFile.id].length) return;
    if (stats.available === 0) return;

    const clip = newClip({
      mediaFileId: selectedFile.id,
      startTime: 0,
      endTime: 0,
    });

    const res = clipsApi(selector, storyBoard, linkedClips).add(
      [clip],
      sbApi(storyBoard).validateAddClipPosition(sbPosition, 'startTime')
    );
    if (!res) {
      Error.addClip.noStoryboardCell();
      return;
    }

    dispatch(setRecentlyMovedClips([clip.clipId]));
    dispatch(passFileAccessedAt(selectedFile.id));
    dispatch(
      handleClips({
        data: res,
        backupParams: { title: 'Add Image', action: 'addClip', activeClip: [activeClip, clip.clipId] },
      })
    );
  };
};
